














import type { SigningPageUser } from '@getaccept/lib-shared/src/types/signing-page-user';
import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';

export default defineComponent({
  props: {
    sender: {
      type: Object as PropType<SigningPageUser>,
      required: true,
    },
    company: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const title = computed((): string => {
      const { title } = props.sender;
      if (title && props.company) {
        return `${title} ${t('role_at')} ${props.company}`;
      }
      if (title) {
        return title;
      }
      if (props.company) {
        return props.company;
      }
      return '';
    });

    return {
      title,
    };
  },
});
